var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: { title: _vm.$t("home.bookMySix"), isShowFollow: false },
              on: { open: _vm.opened },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "filter-container-content" }, [
              _c(
                "div",
                { staticStyle: { margin: "20px 20px 0" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "upload-demo",
                      attrs: {
                        multiple: "",
                        accept: ".xls,.xlsx",
                        action: "#",
                        "auto-upload": false,
                        limit: 1,
                        "before-upload": _vm.beforeAvatarUpload,
                        "http-request": _vm.uploadFile,
                        "file-list": _vm.fileList,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-document-checked",
                            size: "small",
                            plain: "",
                            type: "primary",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("home.selectFile")) + "\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [_vm._v(_vm._s(_vm.$t("home.selectFileMessage")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        margin: "20px 0 0px 0",
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: {
                            "text-align": "right",
                            margin: "20px 0",
                          },
                          attrs: { type: "primary", plain: "" },
                          on: { click: _vm.handleUploadFile },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("home.selectSubmit")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "margin-bottom": "20px" } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "el-icon-download icon-box-margin",
                          attrs: { type: "btn-plain-primary", plain: "" },
                          on: { click: _vm.handleDownloadExcel },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("home.DownloadExcelTemplate")) +
                              "\n            "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }